import request from "@/untils/request";

//获取静态资源
export function getResources(pageNum, pageSize) {
  return request({
    url: `/system/resources/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "GET",
  });
}

//获取产品详情
export function getProduct(params) {
  return request({
    url: `/system/product/list?pageNum=1&pageSize=10000`,
    method: "GET",
    params
  });
}

//获取分类列表
export function getCategory(pageNum, pageSize) {
  return request({
    url: `/system/category/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "GET",
  });
}
export function getSmsCode(data) {
  return request({
    url: `/web/email/sendEmail`,
    method: "POST",
    data,
  });
}
export function SmsLogin(data) {
  return request({
    url: `/web/email/login`,
    method: "POST",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}
export function SmsRegister(params, data) {
  return request({
    url: `/web/email/register?code=${params.code}&&uuid=${params.uuid}`,
    method: "POST",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}
